import { initGlobalComponents } from '../modules/global-components.js';

// Inicializa os componentes globais e o formulario de avaliacoes.
const initReviewsPage = () => {
    const container = document.querySelector('.reviews-page-container');

    initGlobalComponents();

    if (!container) {
        return;
    }

    $('.cellphone').mask("(99)9999-99999");

    $('#review-form').on('show.bs.modal', function() {
        $('.captcha-image').each(function() {
            const is_loaded = $(this).hasClass('loaded');

            if (!is_loaded) {
                let captcha_image = container.dataset.captchaImage;
                captcha_image = captcha_image ? 'data:image/jpeg;base64,' + captcha_image : 'index.php?route=tool/captcha';

                $(this).attr('src', captcha_image);
                $(this).addClass('loaded');
            }
        });
    });

    $('#button-review').on('click', function() {
        const photo_input = document.getElementById('input_photos');

        if (photo_input.files.length > 3) {
            console.error(container.dataset.errorMaxImages);
            return;
        }

        const form_data = new FormData(document.querySelector('#review-form form'));
        form_data.set('cellphone', $('input[name=\'cellphone\']').val() || 0);

        $.ajax({
            url: 'index.php?route=module/review/write',
            type: 'post',
            dataType: 'json',
            data: form_data,
            contentType: false,
            processData: false,
            beforeSend: function() {
                $('#button-review').button('loading');
            },
            success: function(json) {
                $('.alert-success, .alert-danger').remove();

                if (json['error']) {
                    $('#review #review-form .modal-dialog .modal-header').after('<div class="alert alert-danger"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
                    $('#button-review').button('reset');
                }

                if (json['success']) {
                    $('#button-review').button('reset');
                    $('#review #review-form .modal-dialog .modal-header').after('<div class="alert alert-success"><i class="fa fa-check-circle"></i> ' + json['success'] + '</div>');

                    $('input[name=\'name\']').val('');
                    $('input[name=\'email\']').val('');
                    $('input[name=\'cellphone\']').val('');
                    $('textarea[name=\'text\']').val('');
                    $('input[name=\'rating\']:checked').prop('checked', false);
                    $('input[name=\'captcha\']').val('');
                    photo_input.value = '';
                    $('#review-upload-grid').empty();
                    $('#review-form .reviewUpload').removeClass('reviewUpload--has-files');

                    $('#captcha').attr('src', 'index.php?route=tool/captcha#' + new Date().getTime());
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.error(XMLHttpRequest.responseText);
            }
        });
    });
};

$(function() {
    initReviewsPage();
});

export default {
    init: initReviewsPage
};
